module.exports = __webpack_public_path__ + "static/media/sample1.7f805af9.jpg";